const FUNCTION_REGION = 'europe-west1';
const DEFAULT_LOCATION = 'eventkasteel';
export { FUNCTION_REGION, DEFAULT_LOCATION };
